import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'

if ($('#companyclient_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#companyclient_form',
    components: {
      RingLoader,
      DcForm,
      TextInput,
      Checkbox
    },
    mixins: [mixins],
    data: {
      companyClientId : null,
      loading: 0,
      companyClient: {
        company: {},
        client: {},
        isActive: true
      },
      form: {
        options: {
          errors: {},
        }
      },
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.companyClientId = $('#entity_id').val()
        this.getCompanyClient()
      }
    },
    methods: {
      updateCompanyClient: function () {
        this.loading++
        const url = Routing.generate('api_patch_company_client', { id: this.companyClientId })

        Vue.http.patch(url, {
          'data': { isActive: this.companyClient.isActive },
        }).then(() => {
          this.loading--
          $(location).attr('href', Routing.generate('company_update', { id: this.companyClient.company.id }))
        }, response => {
          this.handleAjaxError(response, this.form.options)
          this.loading--
        })
      },
      getCompanyClient: function () {
        this.loading++
        const url = Routing.generate('api_get_company_client', { id: this.companyClientId,
          context: 'edit' })
        Vue.http.get(url).then(response => {
          this.companyClient = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    }
  })
}
